import { EventObject, Guard } from 'xstate';

import logger from 'helpers/logger';

/**
 * Use this function when you use a **custom guard**, to ensure a correct value is passed to the guard.
 * It asserts that a value was passed in the `value` prop of the `cond` clause.
 *
 * @example <caption>
 * {
 *   cond: {
 *     type: Guard.IsApplicationType,
 *     value: ApplicationType.CapitalDeposit
 *   }
 * }
 *
 * // start the guard with `assertCustomGuardValue<ApplicationType>(cond)`
 * </caption>
 */
function assertCustomGuardValue<TValue extends string>(
  cond: Guard<unknown, EventObject>,
): asserts cond is { type: string; value: TValue } {
  const isValueValid = 'value' in cond && typeof cond.value === 'string';

  if (!isValueValid) {
    const error = `custom guard used without a 'value' prop: ${JSON.stringify(
      cond,
    )}`;

    logger.error(error);

    if (import.meta.env.MODE === 'development') {
      throw new Error(error);
    }
  }
}

export default assertCustomGuardValue;
